import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BookingItem } from '@fry/booking/lib/booking-items';

import { EditorBookingItemEditStore } from './editor-booking-item-edit.store';
import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';
import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';
import { EditorDialogStore } from '../editor-dialog/editor-dialog.store';


@Component({
    selector: 'eas-editor-booking-item-edit',
    templateUrl: './editor-booking-item-edit.component.html',
    styleUrls: ['./editor-booking-item-edit.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemEditComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  bookingItem: BookingItem;
  replacingItem: EditorBookingItem;
  patchingItem: EditorBookingItem;
  parentPatchingItem: EditorBookingItem;
  patchingItemForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<EditorBookingItemEditComponent>,
    private itemTreeStore: EditorBookingItemTreeStore,
    private itemEditStore: EditorBookingItemEditStore,
    private itemDialogStore: EditorDialogStore
  ) {
    this.patchingItem = null;
  }

  ngOnInit() {
    this.itemTreeStore.bookingItem$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(bookingItem => this.bookingItem = bookingItem);

    this.itemEditStore.replacingItem$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(replacingItem => this.replacingItem = replacingItem);

    this.itemEditStore.patchingItem$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(patchingItem => this.patchingItem = patchingItem);

    this.itemEditStore.parentPatchingItem$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(parentPatchingItem => this.parentPatchingItem = parentPatchingItem);

    this.itemEditStore.patchingItemForm$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(patchingItemForm => this.patchingItemForm = patchingItemForm);
  }

  ngOnDestroy() {
    this.itemEditStore.stopEditing();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSubmit() {
    this.itemEditStore.save(this.patchingItem.id);
    this.itemDialogStore.stopEditing();
    this.dialogRef.close();
  }

  onCancel() {
    this.itemDialogStore.stopEditing();
    this.dialogRef.close();
  }

  getPatchingItemFormControl(key: string): FormControl {
    return this.patchingItemForm.get(key) as FormControl;
  }

  getPatchingItemFormArray(key: string): FormArray {
    return this.patchingItemForm.get(key) as FormArray;
  }

  getPatchingItemFormArrayFormGroup(key: string, index: number): FormGroup {
    return this.getPatchingItemFormArray(key).at(index) as FormGroup;
  }
}
